<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;;color:rgba(52,152,219,1);"
        ></i>
        采购记录
        <div @click="setPage(1)" class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 75%;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;" class="search-box">
        <el-row class="search">
          <el-col :span="4">
            <div class="label">订单编号:</div>
          </el-col>
          <el-col :span="8">
            <el-input clearable size="small" v-model="orderCode" placeholder="订单编号"></el-input>
          </el-col>
          <el-col :span="5">
            <div class="label">供应商:</div>
          </el-col>
          <el-col :span="8">
            <el-autocomplete
              size="small"
              style="width:100%"
              v-model="supplier"
              :fetch-suggestions="querySearchAsync"
              @select="supplierSelect"
            ></el-autocomplete>
          </el-col>
          <el-col :span="4">
            <div class="label">状态:</div>
          </el-col>
          <el-col :span="6">
            <el-select size="small" v-model="state" placeholder="请选择状态">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <div class="label">商品货号:</div>
          </el-col>
           <el-col :span="10">
            <el-input clearable size="small" style="width:85%" v-model="item_no" placeholder="商品货号"></el-input>
          </el-col>
         
        </el-row>
         <el-row>
          <el-col :span="4">
            <div class="label">商品名称:</div>
          </el-col>
          <el-col :span="8">
            <el-input clearable size="small" v-model="stitle" placeholder="商品名称"></el-input>
          </el-col>
          <el-col :span="4">
            <div class="label">订单日期:</div>
          </el-col>
          <el-col :span="6">
            <template>
              <div class="block">
                <!-- <el-date-picker value-format="yyyy-MM-dd" v-model="create_time" size="small" clearable placeholder="订单日期"></el-date-picker> -->
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="create_time"
                  size="small" 
                  clearable 
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="3">
            <div class="label">采购日期:</div>
          </el-col>
          <el-col :span="5">
            <template>
              <div class="block">
                <!-- <el-date-picker value-format="yyyy-MM-dd" v-model="purchase_time" size="small" clearable placeholder="采购日期"></el-date-picker> -->
                 <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="purchase_time"
                  size="small" 
                  clearable 
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="8" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" :summary-method="getSummaries" show-summary border style="width: 100%" ref="multipleTable">
        <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
        <el-table-column prop="title" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="item_no" label="商品货号" align="center"></el-table-column>
        <el-table-column prop="supplier" label="供应商" align="center"></el-table-column>
        <el-table-column label="数量" align="center">
          <template slot-scope="scope">{{scope.row.number}}</template>
        </el-table-column>
        <el-table-column label="金额" align="center">
          <template slot-scope="scope">{{scope.row.money}}</template>
        </el-table-column>
         <el-table-column label="总金额" align="center">
          <template slot-scope="scope">{{scope.row.money * scope.row.number}}</template>
        </el-table-column>
        <el-table-column prop="state" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state == 0" type="primary" disable-transitions>待审核</el-tag>
            <el-tag v-if="scope.row.state == 1" type="success" disable-transitions>待入库</el-tag>
            <el-tag v-if="scope.row.state == 2" type="info" disable-transitions>已入库</el-tag>
            <el-tag v-if="scope.row.state == 3" type="danger" disable-transitions>已作废</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_member" label="采购人" align="center"></el-table-column>
        <el-table-column prop="real_days" label="实际到货期" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column :formatter="dateFormat" prop="create_time" label="下单日期" align="center"></el-table-column>
        <el-table-column :formatter="dateFormat" prop="purchase_time" label="采购日期" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button class="button1" @click="dialogFormVisible = true,alert1(scope.$index)">查看详情</button>
            <button v-if="scope.row.state == 0" class="button1" @click="check(scope.row.id)">审核通过</button>
            <button
              v-if="scope.row.state == 1"
              class="button1"
              @click="showAddInvent(scope.$index)"
            >收货/入库</button>
            <button v-if="scope.row.state > 0" class="button1" @click="return_check(scope.row.id)">反审核</button>
            <button v-if="scope.row.state != 3" class="button1" @click="return_del(scope.row.id)">作废</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_box clearfix" v-if="total > 15">
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="15"
            :current-page.sync="page"
            @current-change="setPage"
            hide-on-single-page
          ></el-pagination>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!--  编辑弹窗 -->
    <el-dialog title="采购详情" :visible.sync="dialogFormVisible" width="1000px">
      <el-form>
        <el-form-item label="订单编号:">
          <el-input
            autocomplete="off"
            v-model="detail.orderCode"
            :disabled="true"
            style="width:60%"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>商品名称:</span>
          <el-input
            autocomplete="off"
            v-model="detail.title"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
          <span style="margin-left:20px">商品货号:</span>
          <el-input
            autocomplete="off"
            v-model="detail.item_no"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>商品规格:</span>
          <el-input
            autocomplete="off"
            v-model="detail.specification"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
          <span style="margin-left:20px">供应商 :</span>
          <el-input
            autocomplete="off"
            v-model="detail.supplier"
            style="width:30%;margin-left:20px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>商品数量:</span>
          <el-input
            autocomplete="off"
            v-model="detail.number"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
          <span style="margin-left:20px">商品价格:</span>
          <el-input
            autocomplete="off"
            v-model="detail.price"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>商品总价:</span>
          <el-input
            autocomplete="off"
            v-model="detail.money"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
          <span style="margin-left:20px">到货期限:</span>
          <el-input
            autocomplete="off"
            v-model="detail.days"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>采购日期:</span>
          <el-input
            autocomplete="off"
            v-model="detail.create_date"
            style="width:30%;margin-left:10px"
            :disabled="true"
          ></el-input>
          <span style="margin-left:20px">采购人:</span>
          <el-input
            autocomplete="off"
            v-model="detail.create_member"
            style="width:30%;margin-left:20px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>审核人:</span>
          <el-input
            autocomplete="off"
            v-model="detail.check_member"
            style="width:30%;margin-left:20px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            v-model="detail.remark"
            style="width:60%"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--  入库信息 -->
    <el-dialog title="入库信息" :visible.sync="showAddInventory" width="1000px">
      <el-form>
        <el-form-item>
          <span>商品名称:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.title"
            style="width:30%;margin-left:10px"
          ></el-input>
          <span style="margin-left:20px">商品货号:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.item_no"
            style="width:30%;margin-left:10px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>商品规格:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.specification"
            style="width:30%;margin-left:10px"
          ></el-input>
          <span style="margin-left:20px">供应商 :</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.supplier"
            style="width:30%;margin-left:20px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>商品数量:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.number"
            style="width:30%;margin-left:10px"
          ></el-input>
          <span style="margin-left:20px">商品价格:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.price"
            style="width:30%;margin-left:10px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>商品总价:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.money"
            style="width:30%;margin-left:10px"
          ></el-input>
          <span style="margin-left:20px">商品品牌:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.brand"
            style="width:30%;margin-left:10px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span>入库单位:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.unit"
            style="width:30%;margin-left:10px"
          ></el-input>
          <span style="margin-left:20px">入库数量:</span>
          <el-input
            autocomplete="off"
            v-model="inventoryDetail.join_number"
            style="width:30%;margin-left:10px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            v-model="inventoryDetail.remark1"
            style="width:60%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addInventory()">确定</el-button>
        <el-button @click="showAddInventory = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "./../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      options: [
        {
          value: null,
          label: "全部"
        },
        {
          value: 0,
          label: "待审核"
        },
        {
          value: 1,
          label: "待收货/入库"
        },
        {
          value: 2,
          label: "已入库"
        },
        {
          value: 3,
          label: "已作废"
        }
      ],
      id: "",
      tableData: [],
      dialogFormVisible: false,

      selectAll: false,
      total: null,
      page: null,
      number: "",
      name: "",
      value1: "",
      token: "",
      username: "",
      inventory: null,
      title: "",
      resType: null,
      numall: null,
      orderCode: null,
      supplier: null,
      state: null,

      multipleSelection: [],
      isIndeterminate: true,
      select: false,

      checked: [],
      idString: "",
      detail: {},
      showAddInventory: false,
      inventoryDetail: {},
      restaurants: [],
      item_no: '',
      purchase_time: [],
      create_time: [],
      stitle: ''
    };
  },
  created() {
    this.$store.state.leftTitle = "采购记录";
    this.$store.state.topActiveId = 3;
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    getSupplier(name) {
      this.axios
        .get(this.serve + "/admin/get_supplier_list", {
          params: {
            name: name,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            var row = [];
            var data1 = data.data;
            for (var i in data1) {
              var a = {};
              a.value = data1[i];
              row[i] = a;
            }
            this.restaurants = row;
          } else {
            this.restaurants = [];
          }
        });
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      console.log(restaurants);
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    supplierSelect(item) {},
    showAddInvent(index) {
      this.showAddInventory = true;
      var inventoryDetail = this.tableData[index];
      this.axios
        .get(this.serve + "/admin/is_has_inventory", {
          params: {
            username: this.username,
            token: this.token,
            title: inventoryDetail.title,
            item_no: inventoryDetail.item_no,
            brand: inventoryDetail.brand
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            inventoryDetail.unit = data.data;
          }
          this.inventoryDetail = inventoryDetail;
        });
    },
    addInventory() {
      var inventoryDetail = this.inventoryDetail;
      inventoryDetail.remark = inventoryDetail.remark1;
      this.axios
        .get(this.serve + "/admin/purchase_enter_inventory", {
          params: {
            username: this.username,
            token: this.token,
            inventoryDetail: JSON.stringify(inventoryDetail),
            orderCode: inventoryDetail.orderCode
          }
        })
        .then(res => {
          this.showAddInventory = false;
          this.inventoryDetail = {};
          this.geting();
          this.$message({
            showClose: true,
            message: "入库成功",
            type: "success",
            offset: 300
          });
        });
    },
    check(id) {
      this.$confirm("确定已仔细审核过此采购信息？", "审核通知", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认审核",
        cancelButtonText: "放弃"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/check_purchase", {
              params: {
                token: this.token,
                username: this.username,
                id: id
              }
            })
            .then(res => {
              this.geting();
              var data = res.data;
              if (data.status == "success") {
                this.$message({
                  showClose: true,
                  message: "审核成功",
                  type: "success",
                  offset: 300
                });
              }else if(data.code == '403'){
                 this.$message.error(data.msg);
              } else {
                this.$message({
                  showClose: true,
                  message: "审核失败",
                  type: "error",
                  offset: 300
                });
              }
            });
        })
        .catch(action => {});
    },
    return_check(id) {
      this.$confirm("此操作将会使当前采购信息回退到待审核,确定要执行当前操作？", "反审核", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "放弃"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/return_check", {
              params: {
                token: this.token,
                username: this.username,
                id: id
              }
            })
            .then(res => {
              this.geting();
              var data = res.data;
              if (data.status == "success") {
                this.$message({
                  showClose: true,
                  message: "反审核成功",
                  type: "success",
                  offset: 300
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "反审核失败",
                  type: "error",
                  offset: 300
                });
              }
            });
        })
    },
     return_del(id) {
      this.$confirm("确定要作废当前采购信息吗？", "作废", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "放弃"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/return_del", {
              params: {
                token: this.token,
                username: this.username,
                id: id
              }
            })
            .then(res => {
              this.geting();
              var data = res.data;
              if (data.status == "success") {
                this.$message({
                  showClose: true,
                  message: "已作废",
                  type: "success",
                  offset: 300
                });
              }else if(data.code=='403'){
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: "error",
                    offset: 300
                  });
              }else {
                this.$message({
                  showClose: true,
                  message: "未作废，请重新操作！",
                  type: "error",
                  offset: 300
                });
              }
            });
        })
    },
    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/purchase_log", {
          params: {
            token: this.token,
            username: this.username,
            page: this.page,
            orderCode: this.orderCode,
            supplier: this.supplier,
            state: this.state,
            item_no: this.item_no,
            create_time: this.create_time,
            purchase_time: this.purchase_time,
            title: this.stitle, 
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            that.total = res.data.data.total;
            that.page = res.data.data.page;

            this.tableData = [];
            var json = res.data.data;
            for (var key in json.results) {
              that.tableData.push(json.results[key]);
            }
          } else {
            this.tableData = [];
            if(data.msg == "无权访问")
            {
              this.role = false
            }
          }
          loading.close();
        });
    },
    alert1(index) {
      var detail = this.tableData[index];
      detail.days = detail.days + "天";
      var timeNew = new Date(parseInt(detail.create_date) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
      detail.create_date = timeNew;
      this.detail = detail;
    },
    submit() {
      // const loading = this.$loading({
      // lock: true,
      // text: "正在上传",
      // spinner: "el-icon-loading",
      // background: "rgba(0, 0, 0, 0.7)"
      // });
      var _this = this;

      this.axios
        .get(this.serve + "/admin/add_inventory", {
          params: {
            username: this.username,
            token: this.token,
            p_id: this.id,
            inventory: this.numall
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "提醒成功",
              type: "success"
            });
            _this.numall = null;
            _this.geting();
          } else if (res.data.status == "error") {
            this.$message.error("操作失败");
          }
        });
    },
    dateFormat(row, column){ // 时间戳格式化
        const daterc = row[column.property]
        if(daterc!=null){
        var date = new Date(parseInt(daterc)*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var year = date.getFullYear(),
            month = ("0" + (date.getMonth() + 1)).slice(-2),
            sdate = ("0" + date.getDate()).slice(-2),
            hour = ("0" + date.getHours()).slice(-2),
            minute = ("0" + date.getMinutes()).slice(-2),
            second = ("0" + date.getSeconds()).slice(-2);
        // 拼接
        var result = year + "-"+ month +"-"+ sdate +" "+ hour +":"+ minute +":" + second;
        // 返回
        return result;
        }
    },
    getSummaries(param) { // 表格列求和
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计'
          } 
          // index >= 3 || index <= 11 是你需要计算的列
          // 当然也可以指定一个或者多个列
          // index === 2 || index === 3 这样值求和第二个与第三个列
          else if (index == 4 || index ==5 || index==6) {
            if(index == 4){
              const values = data.map(item => item['number'])
              sums[index] = eval(values.join("+"));
            }else if(index==5){
              const values2 = data.map(item => item['money'])
              sums[index] = Math.floor( eval(values2.join("+")) *1000)/1000;
            }else if(index==6){
              const values3 = data.map(item =>item['number'] * item['money'])
              sums[index] =Math.floor( eval(values3.join("+")) *1000)/1000;
            }
          } else {
            sums[index] = ''
          }
        })
        return sums
      }


  }
};
</script>
<style lang="scss">
.list {
  .search-box {
    width: 100%;
    height: 130px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 40px;
    top: 2px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 75%;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>